    document.addEventListener('DOMContentLoaded', () => {

      const gridBtn = document.querySelector('.tfd-grid-btn');
      const listBtn = document.querySelector('.tfd-list-btn');

      const productsGrid = document.getElementById('tfd-products-grid');

      const sortSelect = document.getElementById('tfd-sort-select');

      const activeTags = document.getElementById('tfd-active-tags');

      const clearBtn = document.querySelector('.tfd-clear-btn');

      const categoryFilters = document.querySelectorAll('.tfd-category-filter');

      const priceFilters = document.querySelectorAll('.tfd-price-filter');

      const productCount = document.getElementById('tfd-product-count');

      const cards = Array.from(document.querySelectorAll('.tfd-product-card'));

      /* GRID VIEW */

      if(gridBtn){

        gridBtn.addEventListener('click', () => {

          gridBtn.classList.add('active');

      if(listBtn){
      listBtn.classList.remove('active');
    }

          productsGrid.classList.remove('list-view');

        });

      }

      /* LIST VIEW */

      if(listBtn){

        listBtn.addEventListener('click', () => {

          listBtn.classList.add('active');

          if(gridBtn){
      gridBtn.classList.remove('active');
    }

          productsGrid.classList.add('list-view');

        });

      }

      /* SORTING */

      if(sortSelect){

        sortSelect.addEventListener('change', () => {

          const value = sortSelect.value;

          let sortedCards = [...cards];

          if(value === 'price-low'){

            sortedCards.sort((a, b) => {

              return parseFloat(a.dataset.price) - parseFloat(b.dataset.price);

            });

          }

          if(value === 'price-high'){

            sortedCards.sort((a, b) => {

              return parseFloat(b.dataset.price) - parseFloat(a.dataset.price);

            });

          }

          sortedCards.forEach(card => {

            productsGrid.appendChild(card);

          });

        });

      }
/* UPDATE TAGS */

function updateTags(){

  activeTags.innerHTML = '';

  let activeCount = 0;

  /* PRICE TAGS */

  priceFilters.forEach(input => {

    if(input.checked){

      activeCount++;

      const tag = document.createElement('div');

      tag.classList.add('tfd-tag');

      tag.innerHTML = `
        ${input.closest('.tfd-check-row').querySelector('.tfd-check-left span').innerText}
        <span class="tfd-remove-tag">✕</span>
      `;

      tag.querySelector('.tfd-remove-tag').addEventListener('click', () => {

        input.checked = false;

        updateTags();
        updateProducts();
        updatePriceCounts();

      });

      activeTags.appendChild(tag);

    }

  });

  /* CATEGORY TAGS */

  categoryFilters.forEach(input => {

    if(input.checked){

      activeCount++;

      const tag = document.createElement('div');

      tag.classList.add('tfd-tag');

      tag.innerHTML = `
        ${input.value}
        <span class="tfd-remove-tag">✕</span>
      `;

      tag.querySelector('.tfd-remove-tag').addEventListener('click', () => {

        input.checked = false;

        updateTags();
        updateProducts();
        updatePriceCounts();

      });

      activeTags.appendChild(tag);

    }

  });

  /* CLEAR BUTTON */

  if(clearBtn){

    clearBtn.style.display =
      activeCount > 0
        ? 'block'
        : 'none';

  }

}

/* PRICE COUNTS */

function updatePriceCounts(){

  priceFilters.forEach(filter => {

    const range = filter.value.split('-');

    const min = parseFloat(range[0]);
    const max = parseFloat(range[1]);

    let count = 0;

    cards.forEach(card => {

      const price =
        parseFloat(card.dataset.price);

      if(
        price >= min &&
        price <= max
      ){

        count++;

      }

    });

    const row =
      filter.closest('.tfd-check-row');

    const countEl =
      row.querySelector('.tfd-check-count');

    if(countEl){

    countEl.textContent = count;

row.style.display =
  count > 0
    ? 'flex'
    : 'none';

    }

  });

}

      /* PRODUCT FILTER */
    function updateProducts(){

      let visibleCount = 0;

      const checkedPrices = Array.from(priceFilters).filter(item => item.checked);

      const checkedCategories = Array.from(categoryFilters).filter(item => item.checked);

      cards.forEach(card => {

        let show = true;

        const price = parseFloat(card.dataset.price);

        const productType = card.dataset.type || '';
const productTags = card.dataset.tags || '';
const productCollections =
  card.dataset.collections || '';

        /* PRICE FILTER */

        if(checkedPrices.length){

          show = false;

          checkedPrices.forEach(filter => {

            const range = filter.value.split('-');

            const min = parseFloat(range[0]);

            const max = parseFloat(range[1]);

            if(price >= min && price <= max){

              show = true;

            }

          });

        }

        /* CATEGORY FILTER */

        if(show && checkedCategories.length){

          show = false;

          checkedCategories.forEach(filter => {

            const value = filter.value.toLowerCase().trim();

          const normalizedValue = value
      .toLowerCase()
      .replace(/\s+/g, '')
      .replace(/-/g, '');

    const normalizedType = productType
      .toLowerCase()
      .replace(/\s+/g, '')
      .replace(/-/g, '');

    const normalizedTags = productTags
      .toLowerCase()
      .replace(/\s+/g, '')
      .replace(/-/g, '');

    const normalizedCollections =
  productCollections
    .toLowerCase()
    .replace(/\s+/g,'')
    .replace(/-/g,'');

if(
  normalizedType.includes(normalizedValue) ||
  normalizedTags.includes(normalizedValue) ||
  normalizedCollections.includes(normalizedValue)
){
  show = true;
}

          });

        }

        if(show){

          card.style.display = '';

          visibleCount++;

        }else{

          card.style.display = 'none';

        }

      });

      productCount.innerText = visibleCount;
      const pagination =
  document.querySelector('.tfd-pagination');    

if(pagination){

  pagination.style.display =
    visibleCount > 0
      ? 'flex'
      : 'none';

}

    }

      /* REALTIME FILTERS */

      [...priceFilters, ...categoryFilters].forEach(input => {

        input.addEventListener('change', () => {

          updateTags();

          updateProducts();
updatePriceCounts();
        });

      });

      /* CLEAR */

      if(clearBtn){

        clearBtn.addEventListener('click', () => {

          [...priceFilters, ...categoryFilters].forEach(input => {

            input.checked = false;

          });

          updateTags();
          updateProducts();
updatePriceCounts();
        });

      }
      
function updateCategoryCounts(){

  categoryFilters.forEach(filter => {

    let count = 0;

    const value =
      filter.value
        .toLowerCase()
        .replace(/\s+/g,'')
        .replace(/-/g,'');

    cards.forEach(card => {

      const collections =
        (card.dataset.collections || '')
          .toLowerCase()
          .replace(/\s+/g,'')
          .replace(/-/g,'');

      if(
        collections.includes(value)
      ){
        count++;
      }

    });

    const row =
      filter.closest('.tfd-check-row');

    const countEl =
      row.querySelector('.tfd-check-count');

    if(countEl){

      countEl.textContent = count;

    }

    row.style.display =
      count > 0
        ? 'flex'
        : 'none';

  });

}

      /* INIT */

      updateTags();
      updateProducts();
updatePriceCounts();
updateCategoryCounts();
    });console.log('TFD JS Loaded');

    /* =========================
      MOBILE FILTER DRAWER
    ========================= */

    const mobileFilterBtn = document.getElementById('tfd-mobile-filter-btn');

    const sidebar = document.querySelector('.tfd-sidebar');

    const overlay = document.getElementById('tfd-filter-overlay');

    const closeFilter = document.getElementById('tfd-close-filter');

    if(mobileFilterBtn){

      mobileFilterBtn.addEventListener('click', () => {

        sidebar.classList.add('active');

        overlay.classList.add('active');

        document.body.style.overflow = 'hidden';

      });

    }

    function closeMobileFilters(){

      sidebar.classList.remove('active');

      overlay.classList.remove('active');

      document.body.style.overflow = '';

    }

    if(closeFilter){

      closeFilter.addEventListener('click', closeMobileFilters);

    }

    if(overlay){

      overlay.addEventListener('click', closeMobileFilters);

    }

    document.addEventListener('click', (e) => {

      if(
        window.innerWidth <= 767 &&
        sidebar.classList.contains('active') &&
        !sidebar.contains(e.target) &&
        !mobileFilterBtn.contains(e.target)
      ){

        closeMobileFilters();

      }

    });

    /* =========================
      FILTER ACCORDION
    ========================= */

    const filterBoxes = document.querySelectorAll('.tfd-filter-box');


    /* CLOSE ALL FILTERS BY DEFAULT */

    filterBoxes.forEach(box => {

      box.classList.add('closed');

      const toggle = box.querySelector('.tfd-filter-toggle');

      if(toggle){
        toggle.innerHTML = '+';
      }

    });filterBoxes.forEach(box => {

      const head = box.querySelector('.tfd-filter-head');

      head.addEventListener('click', () => {

        const isClosed = box.classList.contains('closed');

        filterBoxes.forEach(item => {

          item.classList.add('closed');

          const icon = item.querySelector('.tfd-filter-toggle');

          if(icon){
            icon.innerHTML = '+';
          }

        });

        if(isClosed){

          box.classList.remove('closed');

          const icon = box.querySelector('.tfd-filter-toggle');

          if(icon){
            icon.innerHTML = '−';
          }

        }

      });

    });
    /* =========================
      PRODUCT CARD QTY
    ========================= */

    document.querySelectorAll('.tfd-product-card').forEach(card => {

      const minus = card.querySelector('.tfd-qty-minus');

      const plus = card.querySelector('.tfd-qty-plus');

      const value = card.querySelector('.tfd-qty-value');

      if(!minus || !plus || !value) return;

      plus.addEventListener('click', () => {

        value.innerText = parseInt(value.innerText) + 1;

      });

      minus.addEventListener('click', () => {

        const qty = parseInt(value.innerText);

        if(qty > 1){
          value.innerText = qty - 1;
        }

      });

    });

    /* =========================
      AJAX ADD TO CART
    ========================= */

    document.querySelectorAll('.tfd-card-add').forEach(button => {

      button.addEventListener('click', async () => {

        const card = button.closest('.tfd-product-card');

        const qty = parseInt(
          card.querySelector('.tfd-qty-value').innerText
        );

        const variantId = button.dataset.variantId;

        button.disabled = true;

        button.innerText = 'ADDING...';

        try{

          const response = await fetch('/cart/add.js', {

            method:'POST',

            headers:{
              'Content-Type':'application/json'
            },

            body:JSON.stringify({
              id:variantId,
              quantity:qty
            })

          });

        if(response.ok){

      button.innerText = 'ADDED ✓';

    const productTitle =
      card.querySelector('.tfd-product-title')?.innerText ||
      'Product';

    showToast(`${productTitle} added to cart.`);
      const cart = await fetch('/cart.js')
        .then(r => r.json());

      let counter = document.querySelector('.tfd-cart__count');

      if(counter){

        counter.textContent = cart.item_count;

      }else if(cart.item_count > 0){

        const cartLink = document.querySelector('.tfd-cart');

        if(cartLink){

          cartLink.insertAdjacentHTML(
            'beforeend',
            `<span class="tfd-cart__count">${cart.item_count}</span>`
          );

        }

      }


            document.dispatchEvent(
              new CustomEvent('cart:update')
            );

          }else{

            button.innerText = 'ERROR';

          }

        }catch(error){

          console.error(error);

          button.innerText = 'ERROR';

        }

        setTimeout(() => {

          button.disabled = false;

          button.innerText = 'ADD TO CART';

        }, 1500);

      });

    });
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {

        const counter =
          document.querySelector('.tfd-cart__count');

        if(counter){

          counter.textContent = cart.item_count;

        }

      });
      /* =========================
   TOAST NOTIFICATION
========================= */

function showToast(message){

  const toast = document.getElementById('tfd-toast');

  if(!toast) return;

  const text = toast.querySelector('.tfd-toast-content span');

  if(text){
    text.textContent = message;
  }

  toast.classList.remove('show');

  requestAnimationFrame(() => {

    toast.classList.add('show');

  });

  clearTimeout(toast.hideTimeout);

  toast.hideTimeout = setTimeout(() => {

    toast.classList.remove('show');

  }, 3000);

}
